import React, { Fragment } from "react";
import classes from "./Footer.module.css";
const Footer=()=>{
    return (
        <Fragment>
<div className={classes.footer}>
    Rohit Multani
</div>
        </Fragment>
    );
};
export default Footer;